import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import Base from './Base'

export class Header extends Base {
  constructor (props) {
    super(props);
    this.state = {
        data: props.data
    }
    }
    toggleSideBar() {
        //document.getElementsByName('body').classList.add('nk-body bg-lighter npc-general has-sidebar has-rtl has-touch as-mobile nk-nio-theme nav-shown');
        if (document.getElementById('sideBarMenu').classList.contains("nk-sidebar-active"))
            document.getElementById('sideBarMenu').classList.remove('nk-sidebar-active');
        else
            document.getElementById('sideBarMenu').classList.add('nk-sidebar-active');
    }
  render() {
      return null;
  }
}
